/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'app/utils/loadable';

export const SearchPage = lazyLoad(
  () => import('./index'),
  module => module.SearchPage,
);
